import { configureStore } from "@reduxjs/toolkit";
import mastersReducer from "./slices/MasterSlice";
import loaderReducer from "./slices/loaderSlice";
import eventsReducer from "./slices/EventSlice";
import podReducer from "./slices/PODSlice";
import orderReducer from "./slices/OrderSlice";
import warningReducer from "./slices/WarningSlice";
import languageReducer from "./slices/LanguageSlice";

// Configure our store combining all the state reducers.
export const store = configureStore({
  reducer: {
    pod: podReducer,
    masters: mastersReducer,
    events: eventsReducer,
    order: orderReducer,
    loader: loaderReducer,
    warning: warningReducer,
    language: languageReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
